import { copy } from "./shared";
import CheckoutForm from "./CheckoutForm";
import "../templates/Template13.css";
import "./CheckoutTemplate13.css";

/*
   Checkout Template 13 — a seamless continuation of sales Template 13
   ("Swiss Minimal Grid", premium light editorial). Reuses Template13.css
   directly (same .clp13-root design system): the real sticky .sw13-nav, the
   editorial .sw13-hero with its top hairline rule + .sw13-title, the sharp
   .sw13-btn.sw13-btn-p button and the hairline .sw13-foot footer. Only the
   form + order summary are checkout-specific (CheckoutTemplate13.css), styled
   as hairline-bordered rectangles to match the template's Swiss look.
*/
export default function CheckoutTemplate13({ data = {}, code }) {
  const c = copy(data);

  return (
    <div className="clp13-root">
      {/* NAV — same sticky bar as the sales page */}
      <nav className="sw13-nav scr">
        <div className="sw13-wrap sw13-nav-in">
          <a href="#top" className="sw13-logo" onClick={(e) => e.preventDefault()}>
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok13-brandtext">{c.brand}</span>}
          </a>
          <span className="cok13-secure">🔒 Secure checkout</span>
        </div>
      </nav>

      {/* HERO — reuses the editorial hero: top hairline rule + big title */}
      <header className="sw13-hero cok13-hero" id="top">
        <div className="sw13-wrap">
          <div className="sw13-rule" />
          <div className="cok13-hero-in">
            <span className="cok13-eyebrow">Checkout</span>
            <h1 className="sw13-title cok13-title">
              Complete your <span className="cok13-accent">enrollment</span>
            </h1>
            {c.sub ? <p className="sw13-sub cok13-sub">{c.sub}</p> : null}
          </div>
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — hairline rectangles in the template's style */}
      <div className="sw13-wrap">
        <CheckoutForm data={data} code={code} p="cok13" c={c} />
      </div>

      {/* FOOTER — same hairline footer as the sales page */}
      <footer className="sw13-foot">
        <div className="sw13-wrap sw13-foot-in">
          <div className="cok13-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
